import { createGlobalStyle, css } from "styled-components"

import colors from "../utils/colors"
import { breakpoints as bp } from "./layout"

export const P = css`
  font-size: 1rem;
  line-height: 1.5;
`

const H1 = css`
  font-size: 2.5rem;
  font-weight: bold;
  line-height: 1.2;

  @media (min-width: ${bp.tabletMin}) {
    font-size: 3.2rem;
  }

  @media (min-width: ${bp.desktopMin}) {
    font-size: 4rem;
  }
`

const H2 = css`
  font-size: 2rem;
  font-weight: bold;
  line-height: 1.2;

  @media (min-width: ${bp.tabletMin}) {
    font-size: 2.5rem;
  }

  @media (min-width: ${bp.desktopMin}) {
    font-size: 3rem;
  }
`

const H3 = css`
  font-size: 1.75rem;
  font-weight: bold;
  line-height: 1.2;

  @media (min-width: ${bp.tabletMin}) {
    font-size: 2rem;
  }

  @media (min-width: ${bp.desktopMin}) {
    font-size: 2.5rem;
  }
`

const H4 = css`
  font-size: 1.5rem;
  font-weight: bold;
  line-height: 1.2;

  @media (min-width: ${bp.tabletMin}) {
    font-size: 2rem;
  }

  @media (min-width: ${bp.desktopMin}) {
    font-size: 1.75rem;
  }
`

const H5 = css`
  font-size: 1.25rem;
  font-weight: bold;
  line-height: 1.2;

  @media (min-width: ${bp.tabletMin}) {
    font-size: 1.75rem;
  }

  @media (min-width: ${bp.desktopMin}) {
    font-size: 1.5rem;
  }
`

export const Large = css`
  font-size: 1.125rem;

  @media (min-width: ${bp.tabletMin}) {
    font-size: 1.3rem;
  }

  @media (min-width: ${bp.desktopMin}) {
    font-size: 1.5rem;
  }
`

export const SemiLarge = css`
  font-size: 1.125rem;
  color: ${colors.gray60};
`

export const Small = css`
  font-size: 0.875rem;
`

export const Inverted = css`
  color: ${colors.white};
`

const GlobalStyle = createGlobalStyle`
  body {
    margin: 0;
    text-align: center;
    color: ${colors.black};
    background-color: ${colors.white};
    font-family: "Space Grotesk";
    font-size: 16px;
    font-weight: 400;
    text-rendering: geometricPrecision;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  input, textarea, button {
    font-family: "Space Grotesk";
  }

  a, a:hover, a:focus, a:visited, a:active {
    text-decoration: none;
  }

  p {
    ${P}
  }

  p, span, a {
    &.semi-large {
      ${SemiLarge};
    }

    &.large {
      ${Large}
    }

    &.bold {
      font-weight: bold;
    }
  }

  .h1, h1 {
    ${H1}
  }

  .h2, h2 {
    ${H2}
  }

  .h3, h3 {
    ${H3}
  }
  
  .h4, h4 {
    ${H4}
  }

  .h5, h5 {
    ${H5}
  }

  p, span, a, h1, h2, h3, h4 {
    &.inverted {
      ${Inverted}
    }
    &.ignore-margin-bottom {
      margin-bottom: 0;
    }
    &.heading--pro {
      em {
        color: ${colors.dark};
        border-bottom: 3px solid ${colors.dark};
      }
    }
    > em {
      color: ${colors.teal};
      font-weight: inherit;
      font-style: normal;
    }
  }

  // Hide Google Recaptcha badge
  .grecaptcha-badge {
    display: none !important;
  }
`

export default GlobalStyle
